import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/home/Home";
import Contact from "./components/contact/Contact";
import About from "./components/About/About";
import Prom from "./components/pages/Prom";
import ViewProduct from './components/pages/ViewProduct.jsx'
import SizeChart from './components/SizeChart/SizeChart.jsx'
function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/about" element={<About />} />
				<Route path="/prom/:year" element={<Prom />} />
				<Route path="/product/id/:style" element={<ViewProduct />} />
					<Route
	path="/size-chart/:category"
	element={<SizeChart />}/>
			</Routes>
		</Router>
	);
}

export default App;
